/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IConditionSettingsModalControllerScope extends IBaseModalControllerScope {
        workflowBlock: models.ConditionWorkflowBlock;
        processConfigId: string;
        isReadonly: boolean;
        conditions: Wars.Domain.Model.Conditions.Condition[];
        conditionChanged(): void;
    }

    export class ConditionSettingsModalController extends BaseModalController {
        scope: IConditionSettingsModalControllerScope;

        constructor(
            $scope: IConditionSettingsModalControllerScope,
            workflowBlock: models.ConditionWorkflowBlock,
            processConfigId: string,
            isReadonly: boolean,
            conditionService: services.ConditionService,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;
            this.scope.workflowBlock = workflowBlock;
            this.scope.isReadonly = isReadonly;
            this.scope.processConfigId = processConfigId;
            this.scope.conditionChanged = () => this.scope.workflowBlock.componentId = this.scope.workflowBlock.conditionDto.conditionId;

            conditionService.getAllConditions(processConfigId).then((conditions) => this.scope.conditions = conditions);
        }
    }
}

warsApp.registerController('ConditionSettingsModalController', ['$scope', 'workflowBlock', 'processConfigId', 'isReadonly', 'conditionService', 'close']);